import { fastHash } from '../utils/fastHash'

const MIN_SALES = 120
const MAX_SALES = 280

export const getFakeSalesCount = (productId: string): number => {
  const normalized = productId?.trim()

  if (!normalized) {
    return MIN_SALES
  }

  const span = MAX_SALES - MIN_SALES + 1

  return MIN_SALES + (fastHash(normalized) % span)
}

export const formatFakeSalesLabel = (count: number): string => {
  return `+${count} vendidos`
}
